<template>
    <div :style="indent" class="tree2ItemContainer" 
            >
        <div v-show="children.length" class="treeExpander2" style="cursor: pointer" @click="doExpand">{{ isExpanded ? '&nbsp;- ' : ' + ' }}</div>
        <div v-show="!children.length" class="treeExpander2">&nbsp;</div>
        <!-- <input ref="cb" type="checkbox" @click="clicked" :checked="isSelected"/> -->
        <drop  class="is-inline"
            @drop="subBundleDrop(id, null, ...arguments)" @dragenter="subBundleDragEnter(...arguments)" @dragleave="subBundleDragLeave(...arguments)" @dragend="dragEnd">
            
            <div ref="subLabel" class="treeNodeMainBundleDropdown left5 handCursor">
                <div ><span class="has-text-coolGreen has-text-weight-normal" @click="loadThisBundle"></span><span class="has-text-weight-normal" @click="loadThisBundle">{{listName}}</span><!-- <span v-if="beenShared">&nbsp;&nbsp;<i class="fas fa-cloud-upload-alt has-text-coolGreen" :class="{red: isDirty}" @click="doOfferUpdatePush"></i></span> --></div>
            </div>

        </drop>
            <tree2 v-show="isExpanded" v-for="(item, ind) in children" 
                :key="ind" 
                :listName="item.listName" 
                :children="item.children" 
                :depth="depth + 1" 
                :id="item.id" 
                :aliasTgtId="item.aliasTgtId"
                :rootBundleId="rootBundleId"
                :isDirty="item.dirt"
                :beenShared="item.beenShared"
                :path="path.slice()">
               
            </tree2>
    </div>
</template>

<script>
    import { AZEventBus } from './AZEventBus'


    export default { 
        name: 'tree2',
        props: ['listName', 'children', 'depth', 'id', 'rootBundleId', 'path', 'isDirty', 'beenShared'],
        data: function(){
            return {
                isSelected: '',
                isExpanded: true,
                counter: 0
            }
        },
        created(){
            //if(this.depth > 0)
                this.path.push({id: this.id, listName: this.listName})
        },
        methods: {
            doExpand: function(){
                this.isExpanded = !this.isExpanded
            },
            loadThisBundle: function(){
                let bundle = this.$root.app.bundles.find(e => {
                    return e.id == this.id
                })
               
                AZEventBus.$emit('subBundleTreeItemClicked', {b: bundle, rootBundleId: this.rootBundleId, path: this.path})
            },

            subBundleDrop: function(id, index, data, event){

            
              
                this.$refs.subLabel.classList.remove('has-background-coolGreen');
                //this.showIt = false
                this.counter = 0;

                if(data.type == 'card'){

                    let fromBundleId = data.bundleId
                    let cardId = data.cardId
                    let cardsIndex = data.cardsIndex
                    let toBundleId = id
                    let before = false;
                    let after;

                    let bInd = this.$root.app.bundles.findIndex(e => {
                        return e.id == id
                    })

                    if(this.$root.app.bundles[bInd].items.length)
                        after = this.$root.app.bundles[bInd].items[0].p;
                    else
                        after = false

                    let self = this
                    function callBack(){
                        //self.$parent.sort()
                        //self.dragging = false

                    }

                    this.$root.app.cardMover(fromBundleId, cardId, toBundleId, before, after, this.$root.app, callBack, cardsIndex)

                } else if(data.type == 'list'){

                    return

                    /* if(data.draggedId == this.subBundle.id) {
                        return
                    }
                    
                    let movedBundle = this.$root.app.bundles.findIndex((e) => {
                        return e.id == data.draggedId
                    })

                    var copyOfBundle,
                    copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))
            

                    if(data.fromSub){
                        this.$root.app.bundleMover(data.bundleId, this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, null);

                    } else { 
                        let rootId = copyOfBundle.branch[0]
                        copyOfBundle = this.$root.app.bundles.find(e => {
                            return e.id == rootId;
                        }) 
                       
                        let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                            return e.id == rootId;
                        })

                        
                        this.$root.app.bundleMover('root', this.bundleId, this.theInd, copyOfBundle, this.$root.app, this.subBundle.branch, draggedListIndex);
                    } */
                }

            },

            dragEnd: function(){
                this.$refs.subLabel.classList.remove('has-background-coolGreen')
                //this.showIt = false;
                this.counter = 0;
            },

            subBundleDragEnter: function(data){
                if(data.type == 'list')
                return
               
            
                if(this.counter == 0){

                    
                    /* if(data.type == 'list')
                        this.showIt = true
                    else */
                    this.$refs.subLabel.classList.add('has-background-coolGreen');
                }
                this.counter++;
            },

            subBundleDragLeave: function(data){
                if(data.type == 'list')
                return

                this.counter--;
                if(this.counter == 0){
                    this.$refs.subLabel.classList.remove('has-background-coolGreen')
                    //this.showIt = false;
                }
            },

            doOfferUpdatePush(){
                var self = this

                var b = this.$root.app.treeNoInbox.find(e => {
                    return e.id == this.rootBundleId
                })

                if(b.hasDirtyBundles){
                    self.$router.push({name: 'sb', params: {theBundle: [b], isPush: true}})
                } else {
                    this.$root.app.showModalOK({message: 'There are no additions to any shared bundles that require updating.'})
                }
        },
            
        },
        computed: {
            indent() {
                return this.depth == 0 ? '' : { 'margin-left': '10px' }//transform: 'translate(20px)'
            }
        }
    }
</script>